


export const setLogin = (data) => {
   console.log("logged in");
   data = JSON.stringify(data);
   localStorage.setItem("login", true);
   localStorage.setItem("config", data);
   localStorage.setItem("isAdmin", data);
}


export const setUserToken = (token) => {
  localStorage.setItem("token",  token);
}



export const getLoggedInUser = () => {
  return JSON.parse(localStorage.getItem("config"));
}

export const checkLogin = () => {
  return (localStorage.getItem("login") === null ? false:true);
}

export const deleteLogin = () => {
  localStorage.removeItem("login");
  localStorage.removeItem("token");
  localStorage.removeItem("config");
  return true;
}



